export default __webpack_public_path__ + "img/bnPyEAXX.ad14f468.svg";